<script>
    export let id;
    export let text;
</script>

<label for="{id}">{text}</label>
<input id="{id}" name="{id}" type="file" accept="image/png, image/jpeg" multiple>